import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import db from './Firebase'
import { collection, getDocs, query, doc, setDoc, getDoc, deleteDoc } from 'firebase/firestore'
// import { getDoc, deleteDoc } from 'firebase/firestore' // templates
import { collectionx, getDocsx, queryx, docx, setDocx, deleteDocx, getDocx } from './SubtaskNewServer'
import payrate from './payrate'
import './Edit.css'
import './EditAny.css'
import Button from 'react-bootstrap/Button'
import moment from 'moment'
import _ from 'lodash'

import Form from 'react-bootstrap/Form'
import { FaArrowDown, FaArrowUp, FaPlus, FaSave, FaSync, FaChevronDown, FaTag, FaClock, FaCoins, FaExclamationTriangle } from 'react-icons/fa'
import { MdDelete, MdClose, MdCalendarToday } from 'react-icons/md'
import { BiCheck, BiReset, BiYen } from 'react-icons/bi'
import { IoAdd } from 'react-icons/io5'
import { AiFillDelete, AiFillCheckCircle } from 'react-icons/ai'
import { Alert, Col, Container, Row, Spinner, Badge } from 'react-bootstrap'
import { syncBalance } from './balanceUtils'
import useWindowDimensions from './useWindowDimensions'
import { mqttUpdate } from './mqttUtils'
import { SUBSUB_DATE_FORMAT, parseSubsubDate, getSubsubValidityStatus } from './subsubValidity'

const TIME_SLOTS = [0, 1, 2, 3, 4, 5];
const SUBSUB_TIME_OPTIONS = [0, 1, 2, 3, 4];
const SUBSUB_TIME_UNIT_SCALE = 2;

const getTimeButtonVariant = (currentValue, option) => {
  if (currentValue == option) {
    return option === 0 ? "danger" : "primary";
  }
  return "outline-primary";
};

const expandDateShorthand = (value) => {
  if (typeof value === 'string' && /^\d+(\.\d+)?d$/i.test(value.trim())) {
    try {
      const xd = Number(value.trim().replace(/d$/i, ''))
      return moment().add(xd, 'days').set('hour', 2).set('minute', 0).set('second', 0).set('millisecond', 0).format('DD/MM/YYYY HH:mm:ss')
    } catch (e) {
      return value
    }
  }
  return value
}

const getCountdownColor = (dateStr) => {
  if (!dateStr) return '#888'
  try {
    const target = parseSubsubDate(dateStr)
    if (!target) return '#888'
    const diffDays = target.diff(moment(), 'hours', true) / 24
    if (diffDays <= 0) return '#ff2d44'
    if (diffDays < 1) return '#fd7e14'
    if (diffDays < 3) return '#ffc107'
    return '#4dabff'
  } catch (e) {
    return '#888'
  }
}

const getCountdownLabel = (dateStr) => {
  if (!dateStr) return null
  try {
    const target = parseSubsubDate(dateStr)
    if (!target || !target.isValid()) return null
    const diffMs = target.diff(moment())
    const absDiff = Math.abs(diffMs)
    const totalHours = Math.floor(absDiff / (1000 * 60 * 60))
    const days = Math.floor(totalHours / 24)
    const hours = totalHours % 24
    return `${days}d ${hours}h`
  } catch (e) {
    return null
  }
}

const formatSubsubValidityDatesForDisplay = (subs) => {
  if (!subs) {
    return
  }

  subs.forEach((sub) => {
    if (!sub?.subsubs) {
      return
    }

    sub.subsubs.forEach((subsub) => {
      if (subsub.hasOwnProperty('validFrom')) {
        const parsedValidFrom = parseSubsubDate(subsub.validFrom)
        if (parsedValidFrom) {
          subsub.validFrom = parsedValidFrom.format(SUBSUB_DATE_FORMAT)
        }
      }

      const parsedExpiryDate = parseSubsubDate(subsub.expiryDate || subsub.validUntil)
      if (parsedExpiryDate) {
        subsub.expiryDate = parsedExpiryDate.format(SUBSUB_DATE_FORMAT)
      }
    })
  })
}

function EditAny() {
  const [allSubs, setAllSubs] = useState([])
  const [stamp, setStamp] = useState([])
  const [dailySn, setDailySn] = useState('')
  const [data, setData] = useState({}) // the daily task stamp
  const [totalTime, setTotalTime] = useState(0)
  const [totalTimeReward, setTotalTimeReward] = useState(0)
  const [optUpdateFlag, setOptUpdateFlag] = useState(0)
  const [doneList, setDoneList] = useState([])
  const [doneListForSubs, setDoneListForSubs] = useState([])
  const [subsubHistoryToSync, setSubsubHistoryToSync] = useState([])
  const [templateName, setTemplateName] = useState('')

  const [savingStamp, setSavingStamp] = useState(false)

  const [stampId, setStampId] = useState('')
  const [showOnlySelected, setShowOnlySelected] = useState(false)
  const [expandedTaskDetails, setExpandedTaskDetails] = useState(new Set())
  const [expandedSubSubDetails, setExpandedSubSubDetails] = useState(new Set())
  const [activeSubsubTimeInput, setActiveSubsubTimeInput] = useState(null)
  const [filterTag, setFilterTag] = useState(null)
  const { height, width } = useWindowDimensions()
  const BODY_MAX_WIDTH = 960
  const CART_PANEL_WIDTH = 280
  const CART_PANEL_OFFSET = 10
  const CART_PANEL_GUTTER = 24
  const safeWindowWidth = width || 0
  const currentBodyWidth = Math.min(safeWindowWidth, BODY_MAX_WIDTH)
  const availableLeftMargin = Math.max(
    (safeWindowWidth - currentBodyWidth) / 2,
    0
  )
  const requiredLeftMargin =
    CART_PANEL_OFFSET + CART_PANEL_WIDTH + CART_PANEL_GUTTER
  const canShowCartSummary =
    safeWindowWidth > 0 && availableLeftMargin >= requiredLeftMargin

  const actionBarRef = useRef(null)
  const editPageRef = useRef(null)

  useLayoutEffect(() => {
    if (!actionBarRef.current || !editPageRef.current) return

    const update = () => {
      const rect = actionBarRef.current.getBoundingClientRect()
      if (rect?.height) {
        editPageRef.current.style.setProperty('--action-bar-height', `${rect.height}px`)
      }
    }

    update()

    let ro
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(update)
      ro.observe(actionBarRef.current)
    }
    window.addEventListener('resize', update)

    return () => {
      window.removeEventListener('resize', update)
      if (ro) ro.disconnect()
    }
  }, [])

  const [stampCreate, setStampCreate] = useState({
    id: '',
    description: '',
    expired: '',
    finish: '',
    expiredDate: '',
    sn: '',
  })

  // const payrate = 0.5
  const toSubsubTimeDisplay = (value) => {
    if (value === '' || value === null || value === undefined) {
      return value
    }
    const numeric = Number(value)
    if (!Number.isFinite(numeric)) {
      return value
    }
    return numeric * SUBSUB_TIME_UNIT_SCALE
  }

  const toSubsubTimeStorage = (value) => {
    if (value === '' || value === null || value === undefined) {
      return 0
    }
    const numeric = Number(value)
    if (!Number.isFinite(numeric)) {
      return 0
    }
    return numeric / SUBSUB_TIME_UNIT_SCALE
  }

  const normalizeSubsubTimesForDisplay = (subs) => {
    if (!subs) {
      return
    }
    subs.forEach((sub) => {
      if (!sub?.subsubs) {
        return
      }
      sub.subsubs.forEach((subsub) => {
        if (subsub.time === undefined || subsub.time === null) {
          subsub.time = toSubsubTimeDisplay(subsub.finish)
        } else {
          subsub.time = toSubsubTimeDisplay(subsub.time)
        }
      })
    })
  }

  const loadStamp = async () => {
    setSavingStamp(true)
    let subs = []
    let mAllSubs = []
    // Load the tasks
    const querySnapshot = await getDocsx(queryx(collectionx(db, 'subtasks')))
    if (querySnapshot.size == 0) {
      console.log('No subtasks found')
      return
    }
    querySnapshot.forEach((doc) => {
      let data = doc.data()
      console.log('data is')
      console.log(data)
      mAllSubs.push(data)
    })

    // Convert date strings to Date objects
    mAllSubs.forEach((bigsub) => {
      if (bigsub.hasOwnProperty('subs')) {
        bigsub.subs.forEach((sub) => {
          if (sub.hasOwnProperty('validFromDate')) {
            console.log('Sub: ', sub.sname, sub.validFromDate)
            sub.validFromDate = moment(sub.validFromDate.toDate()).format("DD/MM/YYYY HH:mm:ss")
          }
          if (sub.hasOwnProperty('expiryDate')) {
            sub.expiryDate = moment(sub.expiryDate.toDate()).format("DD/MM/YYYY HH:mm:ss")
          }
          if (!sub.hasOwnProperty('tags')) {
            sub.tags = ""
          }
          if (sub.hasOwnProperty('allowFeedback')) {
            sub.allowFeedback = String(sub.allowFeedback)
          }
          if (sub.hasOwnProperty('subsubs')) {
            sub.subsubs.forEach((subsub) => {
              if (subsub.time === undefined || subsub.time === null) {
                subsub.time = toSubsubTimeDisplay(subsub.finish)
              } else {
                subsub.time = toSubsubTimeDisplay(subsub.time)
              }
            })
          }
        })
      }
    })

    formatSubsubValidityDatesForDisplay(mAllSubs)


    setAllSubs(mAllSubs)




    // if (dailySn != '') {
    //   // find the index of the dailySn in mAllSubs
    //   let indexOfDailySn = mAllSubs.findIndex((x) => x.sn == dailySn)
    //   setStamp(mAllSubs[indexOfDailySn].subs)
    //   setData(mAllSubs[indexOfDailySn])
    // }



    // Load doneList
    const doneListQuerySnapshot = await getDocsx(queryx(collectionx(db, "doneList")));
    if (doneListQuerySnapshot.size > 0) {
      doneListQuerySnapshot.forEach((doc) => {
        if (doc.id == "default") {
          let data = doc.data();
          // console.log(data)
          if (data.hasOwnProperty("doneList")) {
            // doneList is not empty set doneList (so that they can be appended, not overwritten)
            setDoneList(data.doneList);
            console.log("doneList set");
          }
        }
      });
    }

    // Load doneListForSubs collection
    const doneListForSubsQuerySnapshot = await getDocsx(queryx(collectionx(db, "doneListForSubs")));
    if (doneListForSubsQuerySnapshot.size > 0) {
      doneListForSubsQuerySnapshot.forEach((doc) => {
        if (doc.id == "default") {
          let data = doc.data();
          // console.log(data)
          if (data.hasOwnProperty("doneListForSubs")) {
            // doneList is not empty set doneList (so that they can be appended, not overwritten)
            setDoneListForSubs(data.doneListForSubs);
            console.log("doneListForSubs set");
          }
        }
      });
    }

    // subs.forEach((sub) => {
    //     sub.initialFinish = sub.finish
    // })

    // console.log(mAllSubs)
    setSavingStamp(false)

    if (dailySn != '') { // if the user has selected a stamp, we load it (this case is the case where user hits refresh)
      // find the index of the dailySn in mAllSubs
      let indexOfDailySn = mAllSubs.findIndex((x) => x.sn == dailySn)
      let subs = mAllSubs[indexOfDailySn].subs
      if (mAllSubs[indexOfDailySn].hasOwnProperty('id')) {
        setTemplateName(mAllSubs[indexOfDailySn].id.toLowerCase())
      }
      setStamp(subs)
      setData(mAllSubs[indexOfDailySn])
      setStampId(mAllSubs[indexOfDailySn].id)
    }
  }

  useEffect(() => {
    // Set document title
    document.title = 'Edit Tasks'

    // If locked redirect to home
    if (localStorage.getItem('locked') == 'true') {
      window.location.href = '/'
    }

    loadStamp()
  }, [])

  const isNumeric = (str) => {
    if (typeof str != 'string') return false // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ) // ...and ensure strings of whitespace fail
  }

  const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }

  const applySubTimeUpdate = (sub, value) => {
    sub.time = value
    sub.finish = value * payrate
    sub.initialFinish = value * payrate
  }

  const zeroOutSubsubTimes = (sub) => {
    if (!sub?.subsubs?.length) {
      return
    }
    sub.subsubs.forEach((subsub) => {
      subsub.time = 0
    })
  }

  const toFixed = (number, precision) => {
    try {
      return Number(number).toFixed(precision)
    } catch (error) {
      return 'N/A'
    }
  }

  const getSubsubTimeSum = (sub) => {
    if (!sub?.subsubs?.length) {
      return null
    }
    let sum = 0
    let hasValue = false
    sub.subsubs.forEach((ss) => {
      if (isNumber(ss.time)) {
        sum += Number(ss.time)
        hasValue = true
      }
    })
    return hasValue ? sum : null
  }

  const shouldShowSubsubTimeWarning = (sub, subsubTimeSum) => {
    if (sub.hasOwnProperty('countUp') && sub.countUp == 1) {
      return false
    }
    if (!isNumber(sub.time)) {
      return false
    }
    if (!isNumber(subsubTimeSum)) {
      return false
    }
    return Math.abs(Number(subsubTimeSum) - Number(sub.time)) > 0.01
  }

  const make_serial = (length, terms) => {
    var result = []
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    var charactersLength = characters.length
    for (let term = 0; term < terms; term++) {
      for (var i = 0; i < length; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)))
      }
      if (term != terms - 1) result.push('-')
    }
    return result.join('')
  }

  const handleTextChange = (e, fieldname, sn) => {
    if (fieldname == 'sname') {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]['sname'] = e.target.value
      setStamp(newStamp)
    }
    if (fieldname == 'pay') {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]['finish'] = e.target.value
      if (isNumeric(e.target.value)) {
        // newStamp[indexOfSub]["finish"] = Number(e.target.value);
        newStamp[indexOfSub]['initialFinish'] = Number(e.target.value)
      }
      setStamp(newStamp)
    }
    if (fieldname == 'time') {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]['time'] = e.target.value
      if (isNumeric(e.target.value)) {
        const nextTime = Number(e.target.value)
        applySubTimeUpdate(newStamp[indexOfSub], nextTime)
        if (nextTime === 0) {
          zeroOutSubsubTimes(newStamp[indexOfSub])
        }
      }
      setStamp(newStamp)
    }
    if (fieldname == 'bonusCoeff') {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]['bonusCoeff'] = e.target.value
      /* if (isNumeric(e.target.value)) {
        newStamp[indexOfSub]["bonusCoeff"] = Number(e.target.value);
      } else {
        newStamp[indexOfSub]["bonusCoeff"] = e.target.value;
      } */
      setStamp(newStamp)
    }
    if (fieldname == 'originalTime') {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]['originalTime'] = e.target.value
      if (isNumeric(e.target.value)) {
        // newStamp[indexOfSub]["originalTime"] = Number(e.target.value);
        newStamp[indexOfSub]['originalFinish'] = Number(e.target.value) * payrate
        newStamp[indexOfSub]['time'] = Number(e.target.value)
        newStamp[indexOfSub]['finish'] = Number(e.target.value) * payrate
        newStamp[indexOfSub]['initialFinish'] = Number(e.target.value) * payrate
      }
      setStamp(newStamp)
    }
    if (fieldname == 'originalFinish') {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]['originalFinish'] = e.target.value
      if (isNumeric(e.target.value)) {
        newStamp[indexOfSub]['finish'] = Number(e.target.value)
      }
      setStamp(newStamp)
    }
    if (fieldname == "validFromDate") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]["validFromDate"] = expandDateShorthand(e.target.value)
      setStamp(newStamp)
    }
    if (fieldname == "expiryDate") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn)
      let newStamp = Object.assign([], stamp)
      newStamp[indexOfSub]["expiryDate"] = expandDateShorthand(e.target.value)
      setStamp(newStamp)
    }
    if (fieldname == "allowFeedback") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["allowFeedback"] = e.target.value;
      setStamp(newStamp);
    }
    if (fieldname == "tags") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["tags"] = e.target.value;
      setStamp(newStamp);
    }
    // update optUpdateFlag
    setOptUpdateFlag(optUpdateFlag + 1)
  }

  const setTimeByButton = (sn, value) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn)
    let newStamp = _.cloneDeep(stamp)
    applySubTimeUpdate(newStamp[indexOfSub], value)
    if (value === 0) {
      zeroOutSubsubTimes(newStamp[indexOfSub])
    } else if (newStamp[indexOfSub]?.subsubs?.length) {
      const positiveSubsubs = newStamp[indexOfSub].subsubs.filter(
        (subsub) => isNumber(subsub.time) && Number(subsub.time) > 0
      )
      if (positiveSubsubs.length === 1) {
        const otherSubsubsEmpty = newStamp[indexOfSub].subsubs.every((subsub) => {
          if (subsub === positiveSubsubs[0]) {
            return true
          }
          if (!isNumber(subsub.time)) {
            return true
          }
          return Number(subsub.time) <= 0
        })
        if (otherSubsubsEmpty) {
          positiveSubsubs[0].time = value
        }
      }
    }
    setStamp(newStamp)
  }

  const deleteSub = (sn) => {
    let newStamp = Object.assign([], stamp)
    newStamp = newStamp.filter((x) => x.sn != sn)
    setStamp(newStamp)
  }

  const addSubSub = (sn) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn)
    let newStamp = Object.assign([], stamp)
    newStamp[indexOfSub]['subsubs'].push({
      sn: make_serial(6, 6),
      name: 'Subtask Name',
      finish: 1,
      time: 1,
    })
    setStamp(newStamp)
  }

  const deleteSubSub = (sn1, sn2) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn1)
    let newStamp = Object.assign([], stamp)
    newStamp[indexOfSub]['subsubs'] = newStamp[indexOfSub]['subsubs'].filter((x) => x.sn != sn2)
    setStamp(newStamp)
  }

  const addToDoneList = (sn1, sn2, ssname, sspay) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn1)
    let indexOfSubSub = stamp[indexOfSub]['subsubs'].findIndex((x) => x.sn == sn2)
    let doneListPrime = _.cloneDeep(doneList)
    let sname = stamp[indexOfSub]['sname']
    // if sn1 is not in doneList, add it
    if (!doneListPrime.some((x) => x.sn == sn1)) {
      doneListPrime.push({
        sn: sn1,
        sname: sname,
        stampId: stampId,
        ss: [],
      })
    }
    // Append sn2 to ss of the corresponding element whose sn=sn1
    doneListPrime.forEach((x) => {
      if (x.sn == sn1) {
        x.ss.push({
          sn: sn2,
          name: ssname,
          finish: Number(sspay),
        })
      }
    })
    setDoneList(doneListPrime)

    // Add to subsubHistoryToSync
    let mSubsubHistoryToSync = _.cloneDeep(subsubHistoryToSync);
    mSubsubHistoryToSync.push({
      "sname": sname + "/" + ssname,
      "time": new Date()
    });
    setSubsubHistoryToSync(mSubsubHistoryToSync);

    // Remove sn2 from subsubs of the corresponding element whose sn=sn1
    let newStamp = Object.assign([], stamp)
    newStamp[indexOfSub]['subsubs'] = newStamp[indexOfSub]['subsubs'].filter((x) => x.sn != sn2)
    setStamp(newStamp)
  }

  const addToDoneListForSubs = (sn1) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn1);
    let doneListForSubsPrime = _.cloneDeep(doneListForSubs);
    let sname = stamp[indexOfSub]["sname"];
    // if sn1 is not in doneListForSubs, add it
    if (!doneListForSubsPrime.some((x) => x.sn == sn1)) {
      let finish = Number(stamp[indexOfSub]["finish"]);
      doneListForSubsPrime.push({
        sn: sn1,
        sname: sname,
        stampId: stampId,
        finish: finish
      });
    }
    setDoneListForSubs(doneListForSubsPrime);
    console.log(doneListForSubsPrime);

    // Add to subsubHistoryToSync
    let mSubsubHistoryToSync = _.cloneDeep(subsubHistoryToSync);
    mSubsubHistoryToSync.push({
      "sname": sname,
      "time": new Date()
    });
    setSubsubHistoryToSync(mSubsubHistoryToSync);

    // Remove sn1 from stamp
    let newStamp = Object.assign([], stamp);
    newStamp = newStamp.filter((x) => x.sn != sn1);
    setStamp(newStamp);
  }

  const handleSubTextChange = (e, sn1, sn2, fieldname) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn1)
    let indexOfSubSub = stamp[indexOfSub]['subsubs'].findIndex((x) => x.sn == sn2)
    let newStamp = Object.assign([], stamp)
    if (fieldname == 'name') {
      newStamp[indexOfSub]['subsubs'][indexOfSubSub]['name'] = e.target.value
    }
    if (fieldname == 'finish') {
      newStamp[indexOfSub]['subsubs'][indexOfSubSub]['finish'] = e.target.value
      /* if (isNumeric(e.target.value)) {
        newStamp[indexOfSub]["subsubs"][indexOfSubSub]["finish"] = Number(
          e.target.value
        );
      } else {
        newStamp[indexOfSub]["subsubs"][indexOfSubSub]["finish"] =
          e.target.value;
      } */
    }
    if (fieldname == 'time') {
      newStamp[indexOfSub]['subsubs'][indexOfSubSub]['time'] = e.target.value
      const updatedSubsubSum = getSubsubTimeSum(newStamp[indexOfSub])
      if (isNumber(updatedSubsubSum)) {
        applySubTimeUpdate(newStamp[indexOfSub], Number(updatedSubsubSum))
      }
    }
    if (fieldname == 'validFrom') {
      newStamp[indexOfSub]['subsubs'][indexOfSubSub]['validFrom'] = expandDateShorthand(e.target.value)
    }
    if (fieldname == 'expiryDate') {
      newStamp[indexOfSub]['subsubs'][indexOfSubSub]['expiryDate'] = expandDateShorthand(e.target.value)
    }
    if (fieldname == 'description') {
      newStamp[indexOfSub]['subsubs'][indexOfSubSub]['description'] = e.target.value
    }
    setStamp(newStamp)
  }

  const setSubsubTimeQuick = (sn1, sn2, value) => {
    handleSubTextChange({ target: { value: String(value) } }, sn1, sn2, 'time')
  }

  const addSub = () => {
    if (dailySn == '') {
      return
    }
    let newStamp = Object.assign([], stamp)
    newStamp.push({
      bonusCoeff: 1,
      finish: payrate,
      originalFinish: payrate,
      originalTime: 1,
      initialFinish: payrate,
      time: 1,
      sname: 'New task',
      sn: make_serial(6, 6),
      subsubs: [],
      type: 'subtask',
      // validFromDate: moment().format("DD/MM/YYYY HH:mm:ss"),
      validFromDate: "",
      expiryDate: "",
      tags: ""
    })
    setStamp(newStamp)
  }

  const castData = (mData) => {
    let newData = _.cloneDeep(mData)
    newData.subs.forEach((x) => {
      // Convert finish, time, originalFinish, originalTime, initialFinish, bonusCoeff to number
      x.finish = Number(x.finish)
      x.time = Number(x.time)
      x.originalFinish = Number(x.originalFinish)
      x.originalTime = Number(x.originalTime)
      x.initialFinish = Number(x.initialFinish)
      x.bonusCoeff = Number(x.bonusCoeff)

      // Convert allowFeedback which is a string to number
      if (x.hasOwnProperty("allowFeedback")) {
        x.allowFeedback = Number(x.allowFeedback)
      }

      // console.log('x.validFromDate', x.validFromDate)

      if (x.hasOwnProperty('validFromDate') && x.validFromDate != "") {
        // console.log('111')
        x.validFromDate = moment(x.validFromDate, "DD/MM/YYYY HH:mm:ss").toDate()
      } else {
        // console.log('112')
        if (x.hasOwnProperty('validFromDate')) {
          delete x.validFromDate
        }
      }

      // console.log('x.validFromDate', x.validFromDate)

      if (x.hasOwnProperty('expiryDate') && x.expiryDate != "") {
        x.expiryDate = moment(x.expiryDate, "DD/MM/YYYY HH:mm:ss").toDate()
      } else {
        if (x.hasOwnProperty('expiryDate')) {
          delete x.expiryDate
        }
      }
      if (x.hasOwnProperty('tags') && x.tags != "") {
        // Remove all spaces
        x.tags = x.tags.replace(/\s/g, '')
        // To lower case
        x.tags = x.tags.toLowerCase()
      }
      // if has subsubs, convert finish to number
      if (x.hasOwnProperty('subsubs')) {
        x.subsubs.forEach((y) => {
          const plannedTimeDisplay = Number(y.time ?? 0)
          y.time = Number.isFinite(plannedTimeDisplay)
            ? toSubsubTimeStorage(plannedTimeDisplay)
            : 0
          y.finish = Number(y.finish)
          if (y.hasOwnProperty('validFrom') && y.validFrom != "") {
            y.validFrom = moment(y.validFrom, "DD/MM/YYYY HH:mm:ss").toDate()
          } else {
            delete y.validFrom
          }
          if ((y.hasOwnProperty('expiryDate') || y.hasOwnProperty('validUntil')) && (y.expiryDate || y.validUntil)) {
            y.expiryDate = moment(y.expiryDate || y.validUntil, "DD/MM/YYYY HH:mm:ss").toDate()
            if (y.hasOwnProperty('validUntil')) {
              delete y.validUntil
            }
          } else {
            delete y.expiryDate
            if (y.hasOwnProperty('validUntil')) {
              delete y.validUntil
            }
          }
          if (y.hasOwnProperty('description')) {
            if (!(typeof y.description === 'string' && y.description.trim() !== '')) {
              delete y.description
            }
          }
        })
      }
    })
    newData.totalReward = totalTimeReward
    return newData
  }

  const getCastedDataToSave = () => {
    let newData = _.cloneDeep(data)
    newData.subs = _.cloneDeep(stamp)
    let castedData = castData(newData)

    // Recalculate totalReward
    let totalReward = 0
    castedData.subs.forEach((x) => {
      totalReward += x.finish
    })

    castedData.totalReward = totalReward

    return castedData
  }

  const save = async () => {
    if (dailySn == '') {
      return
    }
    setSavingStamp(true)
    try {
      const castedData = getCastedDataToSave()
      await setDocx(docx(db, 'subtasks', dailySn), castedData)

      if (doneList.length > 0) {
        await saveDoneList()
      }
      if (doneListForSubs.length > 0) {
        await saveDoneListForSubs()
      }
      if (doneListForSubs.length > 0 || doneList.length > 0) {
        await saveSubsubHistory()
      }

      await loadStamp()
      try {
        await mqttUpdate()
      } catch (err) {
        console.error('MQTT update failed:', err)
      }
    } catch (err) {
      console.error('Stamp save failed:', err)
      alert(`Unable to save stamp: ${err.message}`)
    } finally {
      setSavingStamp(false)
    }
  }

  const saveSubsubHistory = async () => {
    console.log(subsubHistoryToSync);
    await setDocx(docx(db, "subsubHistory", 'default'), {
      subsubs: _.cloneDeep(subsubHistoryToSync),
    });

    // alert("Subsub history was updated!");
    setSubsubHistoryToSync([]);
  }

  const saveDoneList = async () => {
    // console.log(doneList)
    await setDocx(docx(db, 'doneList', 'default'), {
      doneList: _.cloneDeep(doneList),
    })
    // alert('Done list was updated!')
    setDoneList([])
  }

  const saveDoneListForSubs = async () => {
    console.log(doneListForSubs);
    await setDocx(docx(db, "doneListForSubs", 'default'), {
      doneListForSubs: _.cloneDeep(doneListForSubs)
    });
    // alert("Done list for subs was updated!");
    setDoneListForSubs([]);
  }

  const resetTime = async () => {
    if (dailySn == '') {
      return
    }
    let docContent = _.cloneDeep(data)
    let totalReward = 0
    if (docContent.subs) {
      docContent.subs.forEach((s) => {
        if (s.hasOwnProperty('countUp') && s.countUp == 1) {
          console.log('countUp task found, skip reset time for ' + s.sname)
          totalReward += s.finish
          return // we do not perform update on countUp tasks
        }
        if (s.hasOwnProperty('originalFinish')) {
          s.finish = s.originalFinish
          s.initialFinish = s.finish
        } else {
          console.log(
            'Did not update stamp reward for sub ' + s.sname + ' because the originalFinish field was not found',
          )
        }
        if (s.hasOwnProperty('originalTime')) {
          s.time = s.originalTime
        } else {
          console.log(
            'Did not update stamp reward for sub ' + s.sname + ' because the originalTime field was not found',
          )
        }
        totalReward += s.finish
      })
      // console.log(docContent.expired)
      docContent.totalReward = totalReward
      docContent.expiredDate = moment().add(3, 'day').toDate()
      docContent.expired = moment().add(3, 'day').toISOString()
      console.log('Extend expiredDate to 3 days from today')
      docContent.description = 'Task plan for ' + moment().format('DD/MM/YYYY')
      let newData = Object.assign({}, docContent)
      await setDocx(docx(db, 'subtasks', dailySn), newData)
      alert('Reset OK!')
      await loadStamp()
      // db.collection('subtasks').doc(dbSn).set(docContent).then(() => console.log('Database updated for ' + dbSn))
    } else {
      console.log('This stamp does not contain any subsubtasks')
    }
  }

  const resetZero = () => {
    if (dailySn == '') {
      alert('No stamp selected!')
      return
    }
    let docContent = _.cloneDeep(data)
    const sourceSubs = stamp?.length ? _.cloneDeep(stamp) : _.cloneDeep(docContent.subs || [])
    let totalReward = 0
    if (sourceSubs.length) {
      sourceSubs.forEach((s) => {
        if (s.hasOwnProperty('countUp') && s.countUp == 1) {
          return
        }
        s.finish = 0
        s.initialFinish = 0
        s.time = 0
        zeroOutSubsubTimes(s)
      })
    }
    totalReward = 0
    docContent.subs = sourceSubs
    setData({ ...docContent, totalReward: totalReward, subs: sourceSubs })
    setStamp(sourceSubs)
    setOptUpdateFlag(optUpdateFlag + 1)
    // alert("Reset OK!")
  }

  const deleteStamp = () => {
    if (dailySn == '') {
      return
    }
    if (window.confirm('Are you sure you want to delete this stamp?')) {
      // Delete the stamp
      deleteDocx(docx(db, 'subtasks', dailySn)).then(() => {
        alert('Stamp deleted!')
        loadStamp()
      })
    }
  }

  const saveToTemplate = async () => {
    let castedData = getCastedDataToSave()
    await setDocx(docx(db, 'templates', templateName), castedData)
    alert('Stamp saved to template library under the name ' + templateName + '!')
  }

  const loadFromTemplate = async () => {
    let docRef = docx(db, 'templates', templateName)
    let docSnap = await getDocx(docRef)
    if (docSnap.exists()) {
      let mData = docSnap.data()
      if (mData.subs != null) {
        mData.subs.forEach((s) => {
          if (s.hasOwnProperty('validFromDate')) {
            s.validFromDate = moment(s.validFromDate).format("DD/MM/YYYY HH:mm:ss")
          }
          if (s.hasOwnProperty('expiryDate')) {
            s.expiryDate = moment(s.expiryDate.toDate()).format("DD/MM/YYYY HH:mm:ss")
          }
        })
        normalizeSubsubTimesForDisplay(mData.subs)
        formatSubsubValidityDatesForDisplay(mData.subs)
      }
      setStamp(mData.subs)
      if (mData.hasOwnProperty('sn')) {
        delete mData.sn
      }
      if (mData.hasOwnProperty('expired')) {
        delete mData.expired
      }
      if (mData.hasOwnProperty('expiredDate')) {
        delete mData.expiredDate
      }
      setData({
        ...mData,
        sn: dailySn,
        expired: data.expired,
        expiredDate: data.expiredDate,
      })
      alert('Stamp loaded from template library under the name ' + templateName + '!')
    } else {
      alert('No template found under the name ' + templateName + '!')
    }
  }

  // const loadTimeAndFinishFromTemplate = async () => {
  //   let docRef = docx(db, 'templates', templateName)
  //   let docSnap = await getDoc(docRef)
  //   if (docSnap.exists()) {
  //     let mData = docSnap.data()
  //     if (!mData.hasOwnProperty('subs')) {
  //       return
  //     }
  //     let templateSubs = mData.subs
  //     let dataClone = _.cloneDeep(data)
  //     dataClone.subs.forEach((s) => {
  //       let templateSub = templateSubs.find((x) => x.sname == s.sname)
  //       // console.log('x', templateSubs)
  //       // console.log('s', s)
  //       if (templateSub) {
  //         s.time = templateSub.time
  //         s.finish = templateSub.finish
  //         s.initialFinish = templateSub.finish
  //       } else {
  //         s.time = 0
  //         s.finish = 0
  //         s.initialFinish = 0
  //       }
  //     })
  //     setStamp(dataClone.subs)
  //     setData(dataClone)

  //     alert('Time and Reward Info Transferred from ' + templateName + '!')
  //   } else {
  //     alert('No template found under the name ' + templateName + '!')
  //   }
  // }

  useEffect(() => {
    console.log('Stamp updated')
    // Refresh the total time units label
    // alert('Stamp change')
    let totalTu = 0
    let totalReward = 0
    stamp.forEach((s) => {
      /* if (s.hasOwnProperty('countUp') && s.countUp == 1) {
        return // skip countUp tasks
      } */
      if (s.time) {
        if (isNumber(s.time)) {
          totalTu += Number(s.time)
        }
      }
      if (s.finish) {
        if (isNumber(s.finish)) {
          totalReward += Number(s.finish)
        }
      }
    })
    setTotalTime(totalTu)
    setTotalTimeReward(totalReward)
  }, [stamp, optUpdateFlag])

  const handleCountUpCheckbox = (sn, checked) => {
    let newStamp = _.cloneDeep(stamp)
    // find the index of property sn in newStamp
    let index = newStamp.findIndex((x) => x.sn === sn)

    if (checked) {
      newStamp[index].countUp = 1
      newStamp[index].time = 0
      newStamp[index].finish = payrate
      newStamp[index].initialFinish = payrate
      newStamp[index].originalFinish = payrate
      newStamp[index].originalTime = 0
    } else {
      if (newStamp[index].hasOwnProperty('countUp')) {
        delete newStamp[index].countUp
      }
    }
    setStamp(newStamp)
    setOptUpdateFlag(optUpdateFlag + 1)
  }

  const handleTemplateNameChange = (e) => {
    setTemplateName(e.target.value)
  }

  const createNewStamp = () => {
    // Cast data to appropriate type
    let mNewStamp = _.cloneDeep(stampCreate)
    mNewStamp.finish = Number(mNewStamp.finish)
    if (mNewStamp.expired == '') {
      mNewStamp.expiredDate = moment().add(14, 'day').toDate()
      mNewStamp.expired = moment().add(14, 'day').toISOString()
    } else {
      mNewStamp.expiredDate = moment(mNewStamp.expired, 'DD/MM/YYYY HH:mm:ss').toDate()
      mNewStamp.expired = moment(mNewStamp.expired, 'DD/MM/YYYY HH:mm:ss').toISOString()
    }
    mNewStamp.subs = []
    mNewStamp.id = mNewStamp.id.toUpperCase()
    mNewStamp.sn = mNewStamp.id + '-' + make_serial(6, 6)
    mNewStamp.tname = mNewStamp.description
    mNewStamp.totalReward = 0
    mNewStamp.validFrom = moment().toDate()

    // Save to database
    setDocx(docx(db, 'subtasks', mNewStamp.sn), mNewStamp).then(() => {
      alert('New stamp created!')
      loadStamp()
    })
  }

  const handleStampCreateChange = (e, fieldname) => {
    let mStampCreate = _.cloneDeep(stampCreate)
    if (fieldname == 'id') {
      mStampCreate.id = e.target.value
    }
    if (fieldname == 'description') {
      mStampCreate.description = e.target.value
    }
    if (fieldname == 'expired') {
      mStampCreate.expired = e.target.value
    }
    if (fieldname == 'finish') {
      mStampCreate.finish = e.target.value
    }
    setStampCreate(mStampCreate)
  }

  const appendFromTemplate = async () => {
    let docRef = docx(db, 'templates', templateName)
    let docSnap = await getDocx(docRef)
    if (docSnap.exists()) {
      let mData = docSnap.data()

      console.log('mData', mData)

      // Fix the datetime in the template first
      try {
        mData.subs.forEach((x) => {
          if (x.hasOwnProperty('validFromDate')) {
            x.validFromDate = moment(x.validFromDate).format("DD/MM/YYYY HH:mm:ss")
          }
          if (x.hasOwnProperty('expiryDate')) {
            x.expiryDate = moment(x.expiryDate.toDate()).format("DD/MM/YYYY HH:mm:ss")
          }
        })
        normalizeSubsubTimesForDisplay(mData.subs)
        formatSubsubValidityDatesForDisplay(mData.subs)
      } catch (e) {
        console.log('Error in fixing datetime in the template')
        console.log(e)
      }

      let newStampFromScratch = _.cloneDeep(stamp)

      // Iterate through each subtasks in the template mData 
      if (mData.subs != null) {
        mData.subs.forEach((s) => {
          // Check if s.sname (subtask in template) is already in newStamp
          // if not, append it to newStamp
          let found = stamp.findIndex((x) => x.sname == s.sname)
          if (found == -1) {
            // Append s to stamp
            newStampFromScratch.push(s)
          }
        })
      }

      setStamp(newStampFromScratch)

      let newData = _.cloneDeep(data)
      newData.subs = newStampFromScratch

      // if (mData.hasOwnProperty('sn')) {
      //   delete mData.sn
      // }
      // if (mData.hasOwnProperty('expired')) {
      //   delete mData.expired
      // }
      // if (mData.hasOwnProperty('expiredDate')) {
      //   delete mData.expiredDate
      // }

      setData({
        ...newData,
        sn: dailySn,
        expired: data.expired,
        expiredDate: data.expiredDate,
      })
      alert('Stamp appended from template library under the name ' + templateName + '!')
    } else {
      alert('No template found under the name ' + templateName + '!')
    }
  }

  const promoteToTop = (sname) => {
    let newStamp = _.cloneDeep(stamp)
    let found = newStamp.findIndex((x) => x.sname == sname)
    if (found != -1) {
      let s = newStamp.splice(found, 1)
      newStamp.unshift(s[0])
      setStamp(newStamp)
      setData({ ...data, subs: newStamp })
    }
  }

  const demoteToBottom = (sname) => {
    let newStamp = _.cloneDeep(stamp)
    let found = newStamp.findIndex((x) => x.sname == sname)
    if (found != -1) {
      let s = newStamp.splice(found, 1)
      newStamp.push(s[0])
      setStamp(newStamp)
      setData({ ...data, subs: newStamp })
    }
  }

  const moveUp = (sname) => {
    let newStamp = _.cloneDeep(stamp)
    let found = newStamp.findIndex((x) => x.sname == sname)
    if (found != -1 && found != 0) {
      let s = newStamp.splice(found, 1)
      newStamp.splice(found - 1, 0, s[0])
      setStamp(newStamp)
      setData({ ...data, subs: newStamp })
    }
  }

  const moveDown = (sname) => {
    let newStamp = _.cloneDeep(stamp)
    let found = newStamp.findIndex((x) => x.sname == sname)
    if (found != -1 && found != newStamp.length - 1) {
      let s = newStamp.splice(found, 1)
      newStamp.splice(found + 1, 0, s[0])
      setStamp(newStamp)
      setData({ ...data, subs: newStamp })
    }
  }

  const handleStampSelectFromDropDown = (subSn) => {
    if (subSn == '') {
      return
    }
    console.log('subSn: ' + subSn)
    setDailySn(subSn)
    // Find the sub with sn in allSubs
    let sub = allSubs.find((x) => x.sn == subSn)
    // if subSn contains "DAILY"
    if (subSn.includes('DAILY')) {
      alert('To edit the daily stamp, you will be redirected to the daily stamp editor')
      window.location.href = '/edit'
      return
    }
    let subs = sub.subs
    // console.log(sub)
    if (sub.hasOwnProperty('id')) {
      setTemplateName(sub.id.toLowerCase())
    }
    setStamp(subs) // is the subs of the daily stamp
    setData(sub) // is the daily stamp
    setStampId(sub.id)
  }

  const getHoursMinutesFromMinutes = (minutes) => {
    let hours = Math.floor(minutes / 60)
    let mins = minutes % 60
    if (mins < 10) {
      mins = '0' + mins
    }
    return hours + ':' + mins
  }

  const getRemainingDays = (date) => {
    if (!date) {
      return ''
    }
    try {
      const now = moment()
      const target = moment(date, 'DD/MM/YYYY HH:mm:ss')
      if (!target.isValid()) return '?'
      const diffMs = target.diff(now)
      const absDiff = Math.abs(diffMs)
      const totalHours = Math.floor(absDiff / (1000 * 60 * 60))
      const days = Math.floor(totalHours / 24)
      const hours = totalHours % 24
      const sign = diffMs < 0 ? '-' : ''
      return `${sign}${days}d ${hours}h`
    } catch (error) {
      return '?'
    }
  }

  const getRelativeDateLabel = (dateStr) => {
    if (!dateStr) return null
    try {
      const target = moment(dateStr, 'DD/MM/YYYY HH:mm:ss')
      if (!target.isValid()) return null
      const now = moment()
      const diffMs = target.diff(now)
      const absDiff = Math.abs(diffMs)
      const totalHours = Math.floor(absDiff / (1000 * 60 * 60))
      const days = Math.floor(totalHours / 24)
      const hours = totalHours % 24
      const dayName = target.format('dddd')
      if (diffMs >= 0) {
        return `${dayName}, in ${days}d ${hours}h`
      } else {
        return `${dayName}, ${days}d ${hours}h ago`
      }
    } catch (e) {
      return null
    }
  }

  const isDateInFuture = (date) => {
    if (!date) {
      return false
    }
    try {
      return moment(date, 'DD/MM/YYYY HH:mm:ss').isAfter(moment())
    } catch (error) {
      return false
    }
  }

  const getRemainingDaysInNumber = (date) => {
    try {
      let today = moment();
      let expiry = moment(date, "DD/MM/YYYY HH:mm:ss");
      let diff = expiry.diff(today, 'days')
      return diff;
    } catch (error) {
      return -1
    }
  }

  const toggleSubSubDetails = (subsubSn) => {
    const newSet = new Set(expandedSubSubDetails);
    if (newSet.has(subsubSn)) {
      newSet.delete(subsubSn);
    } else {
      newSet.add(subsubSn);
    }
    setExpandedSubSubDetails(newSet);
  }

  const syncBalanceAndReload = async () => {
    await syncBalance()
    try {
      await mqttUpdate()
    } catch (err) {
      console.error('MQTT update failed:', err)
    }
    // Refresh the page
    window.location.reload()
  }

  return (
    <div className='AppRootDesktop'>
      {savingStamp && (
        <div className='LoadingIcon'>
          <Spinner animation='border' role='status'></Spinner>
        </div>
      )}
      <div className='AppRootInnerOverlay'>
        <Container ref={editPageRef} fluid className='edit-page'>
          <div ref={actionBarRef} className='action-bar'>
            <h1>Edit Any Stamp</h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.15rem' }}>
              <div className='action-bar-stats'>
                <div>Time units: {totalTime.toFixed(0)} / {getHoursMinutesFromMinutes(Math.round(totalTime * 25))}</div>
                <div>Total pay: {totalTimeReward.toFixed(2)}</div>
              </div>
              {savingStamp && (
                <Spinner style={{ marginRight: 4 }} animation='border' variant='primary' />
              )}
              {!savingStamp && (
                <Button
                  variant='success'
                  onClick={() => {
                    save()
                  }}>
                  <FaSave></FaSave> Save
                </Button>
              )}
              <Button
                variant='primary'
                onClick={() => {
                  resetTime()
                }}>
                <BiReset></BiReset>
              </Button>
              <Button
                variant='danger'
                onClick={() => {
                  resetZero()
                }}>
                <BiReset></BiReset>
              </Button>
              <Button
                variant='success'
                onClick={() => {
                  syncBalanceAndReload()
                }}>
                <FaSync></FaSync>
              </Button>
            </div>
          </div>

          {canShowCartSummary && (
            <div className="AllTasksSummarySlot">
              <div className="AllTasksSummary">
                <div className="AllTasksSummaryHeader">
                  <div>CART</div>
                  <div className="AllTasksSummaryGlobalToggle">
                    <Form.Check
                      type='switch'
                      id="cartGlobalToggle"
                      label={showOnlySelected ? 'Selected' : 'All'}
                      onChange={(e) => setShowOnlySelected(e.target.checked)}
                      checked={showOnlySelected}
                    />
                  </div>
                </div>
                {(showOnlySelected ? stamp.filter((s) => isNumber(s.time) && Number(s.time) > 0) : stamp).map((sub, subIndex) => {
                  const isSelected = isNumber(sub.time) && Number(sub.time) > 0;
                  const hasSubsubs = sub.hasOwnProperty('subsubs') && sub.subsubs && sub.subsubs.length > 0;
                  const subsubTimeSum = getSubsubTimeSum(sub);
                  const showSubsubTimeWarning = shouldShowSubsubTimeWarning(sub, subsubTimeSum);
                  // Find the actual index in the full stamp array for drag-and-drop
                  const actualIndex = stamp.findIndex((x) => x.sn === sub.sn);
                  const subtaskCountdownLabel = getCountdownLabel(sub.expiryDate);
                  const subtaskCountdownColor = getCountdownColor(sub.expiryDate);
                  return (
                    <div
                      key={sub.sn}
                      className={`AllTasksSummaryBlock ${isSelected ? 'AllTasksSummaryBlockSelected' : ''}`}
                      draggable
                      onDragStart={(e) => {
                        e.dataTransfer.effectAllowed = 'move';
                        e.dataTransfer.setData('text/plain', JSON.stringify({ type: 'subtask', index: actualIndex, sn: sub.sn }));
                        e.currentTarget.style.opacity = '0.5';
                      }}
                      onDragEnd={(e) => {
                        e.currentTarget.style.opacity = '1';
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.dataTransfer.dropEffect = 'move';
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                        if (data.type === 'subtask' && data.index !== actualIndex) {
                          const newStamp = _.cloneDeep(stamp);
                          const draggedItem = newStamp[data.index];
                          newStamp.splice(data.index, 1);
                          newStamp.splice(actualIndex, 0, draggedItem);
                          setStamp(newStamp);
                        }
                      }}
                    >
                      <div 
                        className="AllTasksSummaryTitleRow"
                        onClick={(e) => {
                          e.stopPropagation();
                          const element = document.getElementById(`subtask-${sub.sn}`);
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            // Add highlight animation
                            element.classList.add('scroll-highlight');
                            setTimeout(() => {
                              element.classList.remove('scroll-highlight');
                            }, 1500);
                          }
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="AllTasksSummaryTitle">{sub.sname}</div>
                        {showSubsubTimeWarning && (
                          <FaExclamationTriangle
                            className="AllTasksSummaryWarningIcon"
                            title="Subsub time sum does not match task time"
                          />
                        )}
                        <div className="AllTasksSummaryBlank"></div>
                        <div className="AllTasksSummaryTime">{Number(sub.time || 0).toFixed(0)}</div>
                        {subtaskCountdownLabel && (
                          <span className="AllTasksSummaryCartCalendar" style={{ color: subtaskCountdownColor }}>
                            / <MdCalendarToday style={{ verticalAlign: 'middle', marginBottom: 2 }} /> ({subtaskCountdownLabel})
                          </span>
                        )}
                      </div>
                      {hasSubsubs && (
                        <div className="AllTasksSummarySubsubs">
                          {sub.subsubs.map((subsub, subsubIndex) => {
                            // Find the actual index in the subsubs array
                            const actualSubsubIndex = sub.subsubs.findIndex((x) => x.sn === subsub.sn);
                            const validityStatus = getSubsubValidityStatus(subsub)
                            return (
                              <div
                                key={subsub.sn}
                                className="AllTasksSummarySubsubBlock"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const element = document.getElementById(`subsubtask-${subsub.sn}`);
                                  if (element) {
                                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    // Add highlight animation
                                    element.classList.add('scroll-highlight');
                                    setTimeout(() => {
                                      element.classList.remove('scroll-highlight');
                                    }, 1500);
                                  }
                                }}
                                style={{ cursor: 'pointer', ...validityStatus.borderStyle }}
                                draggable
                                onDragStart={(e) => {
                                  e.stopPropagation();
                                  e.dataTransfer.effectAllowed = 'move';
                                  e.dataTransfer.setData('text/plain', JSON.stringify({
                                    type: 'subsub',
                                    subIndex: actualIndex,
                                    subsubIndex: actualSubsubIndex,
                                    subSn: sub.sn,
                                    subsubSn: subsub.sn
                                  }));
                                  e.currentTarget.style.opacity = '0.5';
                                }}
                                onDragEnd={(e) => {
                                  e.currentTarget.style.opacity = '1';
                                }}
                                onDragOver={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  e.dataTransfer.dropEffect = 'move';
                                }}
                                onDrop={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                                  if (data.type === 'subsub' && data.subSn === sub.sn && data.subsubIndex !== actualSubsubIndex) {
                                    const newStamp = _.cloneDeep(stamp);
                                    const subIndexInStamp = newStamp.findIndex((x) => x.sn === sub.sn);
                                    if (subIndexInStamp !== -1 && newStamp[subIndexInStamp].subsubs) {
                                      const draggedSubsub = newStamp[subIndexInStamp].subsubs[data.subsubIndex];
                                      newStamp[subIndexInStamp].subsubs.splice(data.subsubIndex, 1);
                                      newStamp[subIndexInStamp].subsubs.splice(actualSubsubIndex, 0, draggedSubsub);
                                      setStamp(newStamp);
                                    }
                                  }
                                }}
                              >
                                <div className="AllTasksSummarySubsubTitle">{subsub.name || 'Unnamed'}</div>
                                <div className="AllTasksSummarySubsubTime">{Number(subsub.time || 0).toFixed(0)}</div>
                                {validityStatus.label && (
                                  <div className="AllTasksSummarySubsubTiming" style={{ color: validityStatus.labelColor }}>
                                    {validityStatus.label}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className='BodyEdit'>
            <div className='task-card selector-card'>
              <div className='section-title'>Choose a stamp</div>
              <Form.Group controlId='formSubTaskSelect'>
                <Form.Label>Choose a SubTask to edit</Form.Label>
                <Form.Select
                  value={dailySn || ''}
                  onChange={(e) => {
                    handleStampSelectFromDropDown(e.target.value)
                  }}>
                  <option value=''>Choose a SubTask</option>
                  {allSubs.map((sub) => (
                    <option key={sub.sn} value={sub.sn}>
                      {sub.tname}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {/* <Row className='selector-stats'>
                <Col xs={6}>
                  <span>Data SN: {data.sn || '—'}</span>
                </Col>
                <Col xs={6} className='text-end'>
                  <span>Current SN: {dailySn || '—'}</span>
                </Col>
              </Row> */}
              {/* <div className='selector-meta'>Template ID: {stampId || '—'}</div> */}
              <div className='button-group button-group-sm'>
                <Button
                  variant='outline-danger'
                  onClick={() => {
                    deleteStamp()
                  }}>
                  <MdDelete></MdDelete> Delete Stamp
                </Button>
              </div>
            </div>

            <div className='TemplateControls template-card'>
              <div className='section-title'>Templates</div>
              <Form.Group controlId='templateNameInput'>
                <Form.Label>Template name</Form.Label>
                <Form.Control
                  type='text'
                  value={templateName}
                  onChange={(e) => handleTemplateNameChange(e)}
                />
              </Form.Group>
              {templateName && templateName.toLowerCase() === 'daily' ? (
                <div className='template-hint'>
                  For the daily stamp, please use the other <a href='/edit'>edit</a> interface!
                </div>
              ) : (
                <div className='button-group'>
                  <Button
                    variant='success'
                    onClick={() => {
                      saveToTemplate()
                    }}>
                    <FaSave></FaSave> Save to Template
                  </Button>
                  <Button
                    variant='warning'
                    onClick={() => {
                      loadFromTemplate()
                    }}>
                    <FaPlus></FaPlus> Load from Template
                  </Button>
                  <Button
                    variant='primary'
                    onClick={() => {
                      appendFromTemplate()
                    }}>
                    <FaPlus></FaPlus> Append from Template
                  </Button>
                </div>
              )}
            </div>

            <Row>
              {stamp.filter(sub => {
                if (!filterTag) return true;
                if (!sub.tags) return false;
                return sub.tags.split(',').includes(filterTag);
              }).map((sub) => {
                const subsubTimeSum = getSubsubTimeSum(sub);
                const showSubsubTimeWarning = shouldShowSubsubTimeWarning(sub, subsubTimeSum);
                return (
                <Col xs={12} key={sub.sn}>
                  <div
                    id={`subtask-${sub.sn}`}
                    data-subtask-id={sub.sn}
                    className={`${getRemainingDaysInNumber(sub.validFromDate) > 0 ? 'SubTaskGrayedOut' : ''} ${sub.finish > 0 ? 'SubTaskSelect' : ''
                      } task-card`}>
                    <div className="task-card__header">
                      <div className="task-card__title-block">
                        <span className="task-card__label">Name</span>
                        <input
                          type="text"
                          className="form-control task-card__title-input"
                          value={sub.sname}
                          onChange={(e) => {
                            handleTextChange(e, "sname", sub.sn);
                          }}
                        ></input>
                      </div>
                      <div className="task-card__status-item mobile-hide-datetime">
                        <span className="task-card__status-label">Valid from</span>
                        <span className="task-card__status-value">{getRemainingDays(sub.validFromDate)}</span>
                      </div>
                      <div className="task-card__status-item mobile-hide-datetime">
                        <span className="task-card__status-label">Expiry date</span>
                        <span className="task-card__status-value">{getRemainingDays(sub.expiryDate)}</span>
                      </div>
                    </div>

                    {/* Tags Section */}
                    {sub.tags && sub.tags.length > 0 && (
                      <div className="task-card__tags" style={{ padding: "0 0 4px 0", display: "flex", flexWrap: "wrap", gap: "4px" }}>
                        {sub.tags.split(',').filter(t => t.trim() !== '').map((tag, tagIndex) => {
                          const isSelected = filterTag === tag;
                          return (
                            <Badge
                              key={tagIndex}
                              bg={isSelected ? "primary" : "secondary"}
                              style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                              onClick={() => {
                                if (isSelected) {
                                  setFilterTag(null);
                                } else {
                                  setFilterTag(tag);
                                }
                              }}
                            >
                              {tag.toUpperCase()}
                              {isSelected && <MdClose size={14} />}
                            </Badge>
                          );
                        })}
                      </div>
                    )}

                    <div className="task-card__time-bar">
                      <div className="task-card__label">Time focus</div>
                      <div className="time-buttons">
                        {TIME_SLOTS.map((slot) => (
                          <Button
                            key={`${sub.sn}-time-${slot}`}
                            variant={getTimeButtonVariant(sub.time, slot)}
                            onClick={() => setTimeByButton(sub.sn, slot)}
                          >
                            {slot}
                          </Button>
                        ))}
                      </div>
                    </div>
                    {showSubsubTimeWarning && (
                      <Alert variant="warning" className="subsub-time-warning">
                        Subsub time sum ({toFixed(subsubTimeSum, 2)}) does not match task time ({toFixed(sub.time, 2)}).
                      </Alert>
                    )}

                    <div className="task-card__details-section">
                      <div
                        className="task-card__details-header"
                        onClick={() => {
                          const newExpanded = new Set(expandedTaskDetails);
                          if (newExpanded.has(sub.sn)) {
                            newExpanded.delete(sub.sn);
                          } else {
                            newExpanded.add(sub.sn);
                          }
                          setExpandedTaskDetails(newExpanded);
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
                          <FaChevronDown
                            style={{
                              transform: expandedTaskDetails.has(sub.sn) ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.2s ease"
                            }}
                          />
                          <span className="task-card__field-label">TASK DETAILS</span>
                        </div>
                      </div>
                      {expandedTaskDetails.has(sub.sn) && (
                        <div className="task-card__grid">
                          <div className="task-card__field">
                            <span className="task-card__field-label">Time units</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.time}
                              onChange={(e) => {
                                handleTextChange(e, "time", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">
                              Pay{" "}
                              <small>
                                ({sub.hasOwnProperty("initialFinish") ? sub.initialFinish : "N/A"})
                              </small>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.finish}
                              onChange={(e) => {
                                handleTextChange(e, "pay", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Bonus coeff</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.bonusCoeff}
                              onChange={(e) => {
                                handleTextChange(e, "bonusCoeff", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Orig time</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.originalTime}
                              onChange={(e) => {
                                handleTextChange(e, "originalTime", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Orig pay</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.originalFinish}
                              onChange={(e) => {
                                handleTextChange(e, "originalFinish", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field task-card__field--switch">
                            <span className="task-card__field-label">Count up</span>
                            <Form.Check
                              type="switch"
                              id={`countUpSwitch-${sub.sn}`}
                              label=""
                              onChange={(e) => handleCountUpCheckbox(sub.sn, e.target.checked)}
                              checked={sub.hasOwnProperty("countUp") && sub.countUp == 1}
                            />
                          </div>
                          <div className="task-card__field mobile-hide-datetime">
                            <span className="task-card__field-label">
                              Valid from{" "}
                              <small>{getRemainingDays(sub.validFromDate)}</small>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.validFromDate ? sub.validFromDate : ""}
                              onChange={(e) => {
                                handleTextChange(e, "validFromDate", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field mobile-hide-datetime">
                            <span className="task-card__field-label">
                              Expiry date <small>{getRemainingDays(sub.expiryDate)}</small>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.expiryDate ? sub.expiryDate : ""}
                              onChange={(e) => {
                                handleTextChange(e, "expiryDate", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Min minutes for feedback inquiry</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.allowFeedback ? sub.allowFeedback : ""}
                              onChange={(e) => {
                                handleTextChange(e, "allowFeedback", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Tags</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.tags ? sub.tags : ""}
                              onChange={(e) => {
                                handleTextChange(e, "tags", sub.sn);
                              }}
                            ></input>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="task-card__subsubs">
                      {(sub.subsubs || []).map((ss, subsubIndex) => {
                        const actualSubsubIndex = (sub.subsubs || []).findIndex((x) => x.sn === ss.sn);
                        const validityStatus = getSubsubValidityStatus(ss)
                        return (
                          <div
                            key={ss.sn}
                            id={`subsubtask-${ss.sn}`}
                            data-subsubtask-id={ss.sn}
                            draggable
                            className="SubSubTaskEdit"
                            style={validityStatus.borderStyle}
                            onDragStart={(e) => {
                              e.stopPropagation();
                              e.dataTransfer.effectAllowed = 'move';
                              e.dataTransfer.setData('text/plain', JSON.stringify({
                                type: 'subsub',
                                subSn: sub.sn,
                                subsubIndex: actualSubsubIndex,
                                subsubSn: ss.sn
                              }));
                              e.currentTarget.style.opacity = '0.5';
                            }}
                            onDragEnd={(e) => {
                              e.currentTarget.style.opacity = '1';
                            }}
                            onDragOver={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              e.dataTransfer.dropEffect = 'move';
                              e.currentTarget.style.borderTop = '2px solid #007bff';
                            }}
                            onDragLeave={(e) => {
                              e.currentTarget.style.borderTop = '';
                            }}
                            onDrop={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              e.currentTarget.style.borderTop = '';
                              const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                              if (data.type === 'subsub' && data.subSn === sub.sn && data.subsubIndex !== actualSubsubIndex) {
                                const newStamp = _.cloneDeep(stamp);
                                const subIndexInStamp = newStamp.findIndex((x) => x.sn === sub.sn);
                                if (subIndexInStamp !== -1 && newStamp[subIndexInStamp].subsubs) {
                                  const draggedSubsub = newStamp[subIndexInStamp].subsubs[data.subsubIndex];
                                  newStamp[subIndexInStamp].subsubs.splice(data.subsubIndex, 1);
                                  newStamp[subIndexInStamp].subsubs.splice(actualSubsubIndex, 0, draggedSubsub);
                                  setStamp(newStamp);
                                }
                              }
                            }}>
                            <Row>
                              <Col xs={12} md={5}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span
                                    onClick={() => toggleSubSubDetails(ss.sn)}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', flexShrink: 0 }}
                                  >
                                    {expandedSubSubDetails.has(ss.sn) ? (
                                      <FaChevronDown style={{ fontSize: '12px' }} />
                                    ) : (
                                      <FaChevronDown style={{ fontSize: '12px', transform: 'rotate(-90deg)' }} />
                                    )}
                                  </span>
                                  <div style={{ position: 'relative', flex: 1 }}>
                                    <FaTag style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                    <input
                                      type='text'
                                      className='form-control'
                                      value={ss.name}
                                      onChange={(e) => handleSubTextChange(e, sub.sn, ss.sn, 'name')}
                                      style={{ paddingLeft: '32px' }}
                                    ></input>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} md={3}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ width: '24px', flexShrink: 0 }}></span>
                                  <div style={{ position: 'relative', flex: 1 }}>
                                    <FaClock style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                    <input
                                      type='text'
                                      className='form-control'
                                      value={ss.time}
                                      onChange={(e) => handleSubTextChange(e, sub.sn, ss.sn, 'time')}
                                      onFocus={() => setActiveSubsubTimeInput(`${sub.sn}-${ss.sn}`)}
                                      onBlur={() => setActiveSubsubTimeInput(null)}
                                      style={{ paddingLeft: '32px' }}
                                    ></input>
                                    {activeSubsubTimeInput === `${sub.sn}-${ss.sn}` && (
                                      <div
                                        style={{
                                          position: 'absolute',
                                          left: '0',
                                          right: '0',
                                          top: '-34px',
                                          display: 'flex',
                                          gap: '6px',
                                          alignItems: 'center',
                                          zIndex: 5,
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                      >
                                        {SUBSUB_TIME_OPTIONS.map((option) => (
                                          <button
                                            key={`${ss.sn}-time-option-${option}`}
                                            type="button"
                                            className="btn btn-light btn-sm"
                                            style={{ padding: '2px 8px', fontSize: '12px' }}
                                            onClick={() => {
                                              setSubsubTimeQuick(sub.sn, ss.sn, option)
                                              setActiveSubsubTimeInput(null)
                                            }}
                                          >
                                            {option}
                                          </button>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} md={4}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ width: '24px', flexShrink: 0 }}></span>
                                  <div style={{ position: 'relative', flex: 1 }}>
                                    <FaCoins style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                    <input
                                      type='text'
                                      className='form-control'
                                      value={ss.finish}
                                      onChange={(e) => handleSubTextChange(e, sub.sn, ss.sn, 'finish')}
                                      style={{ paddingLeft: '32px' }}
                                    ></input>
                                  </div>
                                </div>
                              </Col>
                              {expandedSubSubDetails.has(ss.sn) && (
                                <div className="SubSubTaskDetails">
                                  <Col xs={12} md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{ width: '24px', flexShrink: 0 }}></span>
                                      <input
                                        type='text'
                                        className='form-control'
                                        value={ss.validFrom ? ss.validFrom : ''}
                                        placeholder='Valid from (DMY HMS)'
                                        onChange={(e) => handleSubTextChange(e, sub.sn, ss.sn, 'validFrom')}
                                        style={{ flex: 1 }}
                                      ></input>
                                    </div>
                                    {getRelativeDateLabel(ss.validFrom) && (
                                      <div style={{ paddingLeft: '32px', fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                                        {getRelativeDateLabel(ss.validFrom)}
                                      </div>
                                    )}
                                  </Col>
                                  <Col xs={12} md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{ width: '24px', flexShrink: 0 }}></span>
                                      <input
                                        type='text'
                                        className='form-control'
                                        value={ss.expiryDate ? ss.expiryDate : ''}
                                        placeholder='Expiry date (DMY HMS)'
                                        onChange={(e) => handleSubTextChange(e, sub.sn, ss.sn, 'expiryDate')}
                                        style={{ flex: 1 }}
                                      ></input>
                                    </div>
                                    {getRelativeDateLabel(ss.expiryDate) && (
                                      <div style={{ paddingLeft: '32px', fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                                        {getRelativeDateLabel(ss.expiryDate)}
                                      </div>
                                    )}
                                  </Col>
                                  <Col xs={12}>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                      <span style={{ width: '24px', flexShrink: 0 }}></span>
                                      <textarea
                                        className="form-control subsub-description-textarea"
                                        value={ss.description ? ss.description : ''}
                                        placeholder="Description (Markdown)"
                                        onChange={(e) => handleSubTextChange(e, sub.sn, ss.sn, 'description')}
                                        rows={4}
                                      ></textarea>
                                    </div>
                                  </Col>
                                </div>
                              )}
                            </Row>
                            {validityStatus.label && (
                              <div className="SubSubTaskTiming" style={{ color: validityStatus.labelColor }}>
                                {validityStatus.label}
                              </div>
                            )}
                            <div className='button-group button-group-sm'>
                              <Button
                                variant='danger'
                                onClick={() => {
                                  deleteSubSub(sub.sn, ss.sn)
                                }}>
                                <MdDelete></MdDelete>
                              </Button>
                              <Button
                                variant='success'
                                onClick={() => {
                                  addToDoneList(sub.sn, ss.sn, ss.name, ss.finish)
                                }}>
                                <BiCheck></BiCheck>
                              </Button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className='subtask-actions'>
                      <Button
                        variant='success'
                        onClick={() => {
                          addSubSub(sub.sn)
                        }}>
                        <IoAdd></IoAdd>
                      </Button>
                      <Button
                        variant='danger'
                        onClick={() => {
                          deleteSub(sub.sn)
                        }}>
                        <AiFillDelete></AiFillDelete>
                      </Button>
                      <Button
                        variant='success'
                        onClick={() => {
                          addToDoneListForSubs(sub.sn)
                        }}>
                        <AiFillCheckCircle></AiFillCheckCircle>
                      </Button>
                      <Button
                        variant='primary'
                        onClick={() => {
                          moveUp(sub.sname)
                        }}>
                        <FaArrowUp></FaArrowUp>
                      </Button>
                      <Button
                        variant='primary'
                        onClick={() => {
                          moveDown(sub.sname)
                        }}>
                        <FaArrowDown></FaArrowDown>
                      </Button>
                      <Button
                        variant='primary'
                        onClick={() => {
                          promoteToTop(sub.sname)
                        }}>
                        <FaArrowUp></FaArrowUp>
                      </Button>
                    </div>
                  </div>
                </Col>
              );
              })}
            </Row>

            <div className='BottomButtons'>
              <Button
                variant='success'
                onClick={() => {
                  addSub()
                }}>
                <FaPlus></FaPlus> Add Sub
              </Button>
              <Button
                variant='success'
                onClick={() => {
                  save()
                }}>
                <FaSave></FaSave> Save
              </Button>
              <Button
                variant='primary'
                onClick={() => {
                  resetTime()
                }}>
                <BiReset></BiReset> Reset to default
              </Button>
              <Button
                variant='danger'
                onClick={() => {
                  resetZero()
                }}>
                <BiReset></BiReset> Reset to zero
              </Button>
              <Button
                variant='outline-danger'
                onClick={() => {
                  deleteStamp()
                }}>
                <MdDelete></MdDelete> Delete Stamp
              </Button>
            </div>

            <div className='task-card new-stamp-card'>
              <div className='section-title'>Add a new stamp</div>
              <Form.Group controlId='newStampId'>
                <Form.Label>ID (5 capital characters)</Form.Label>
                <Form.Control
                  type='text'
                  value={stampCreate.id}
                  onChange={(e) => handleStampCreateChange(e, 'id')}
                />
              </Form.Group>
              <Form.Group controlId='newStampDescription'>
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type='text'
                  value={stampCreate.description}
                  onChange={(e) => handleStampCreateChange(e, 'description')}
                />
              </Form.Group>
              <Form.Group controlId='newStampExpiry'>
                <Form.Label>Expiry date (DD/MM/YYYY HH:mm:ss)</Form.Label>
                <Form.Control
                  type='text'
                  value={stampCreate.expired}
                  onChange={(e) => handleStampCreateChange(e, 'expired')}
                />
              </Form.Group>
              <Form.Group controlId='newStampFinish'>
                <Form.Label>Finish Reward</Form.Label>
                <Form.Control
                  type='text'
                  value={stampCreate.finish}
                  onChange={(e) => handleStampCreateChange(e, 'finish')}
                />
              </Form.Group>
              <Button
                variant='success'
                onClick={() => {
                  createNewStamp()
                }}>
                <FaPlus></FaPlus> Create
              </Button>
            </div>

            <div className='task-card stats-card'>
              {doneList.length} tasks marked as completed (include many subsubs)
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default EditAny
